<span class="btn-entity-create__icon-plus-add icon-plus-add"></span>
<span class="btn-entity-create__text">
   Новый раздел
</span>
